import { gaiaService, storeService, } from '@/services';
import { isChildDong, isParentDong, isAreaRi, isSameDong, } from '@/vuex-store/store-delivery-possible-area/getterUtil';
import { storeDeliveryPossibleAreaMutationType as mutationType, storeDeliveryPossibleAreaActionType as actionType, } from './types';
const actions = {
    [actionType.setIsDialogOpen]({ commit }, isOpen = true) {
        commit(mutationType.SET_IS_DIALOG_OPEN, isOpen);
    },
    // 가이아 데이터 조회
    async [actionType.getSiDoList]({ commit }) {
        const response = await gaiaService.getSido();
        response.data.constantGroups.sort((a, b) => a.name.localeCompare(b.name));
        commit(mutationType.GET_SI_DO_LIST, response.data.constantGroups);
    },
    async [actionType.getSiGunGuList]({ commit }, parentLegalConstantGroupId) {
        const response = await gaiaService.getSiGunGu({
            parentLegalConstantGroupId,
        });
        response.data.constantGroups.sort((a, b) => a.name.localeCompare(b.name));
        commit(mutationType.GET_SI_GUN_GU_LIST, response.data.constantGroups);
    },
    async [actionType.getEupMyeonDongList]({ commit }, parentLegalConstantGroupId) {
        const response = await gaiaService.getEupMyeonDong({
            parentLegalConstantGroupId,
        });
        commit(mutationType.GET_EUP_MYEON_DONG_LIST, response.data.constantGroups);
    },
    // 시도 시군구 선택
    [actionType.setSiDo]({ commit }, item) {
        commit(mutationType.SET_SI_DO, item);
    },
    [actionType.setSiGunGu]({ commit }, item) {
        commit(mutationType.SET_SI_GUN_GU, item);
    },
    // 가이아 데이터 리셋
    [actionType.resetSiDoList]({ commit }) {
        commit(mutationType.RESET_SI_DO_LIST);
    },
    [actionType.resetSiGunGuList]({ commit }) {
        commit(mutationType.RESET_SI_GUN_GU_LIST);
    },
    [actionType.resetEupMyeonDongList]({ commit }) {
        commit(mutationType.RESET_EUP_MYEON_DONG_LIST);
    },
    // 상점별 zoo 데이터
    async [actionType.getStoreDeliveryPossibleAreaList]({ commit }, storeId = '') {
        if (!storeId) {
            return;
        }
        const response = await storeService.getStoreDeliveryPossibleAreaList({
            storeId,
        });
        commit(mutationType.GET_STORE_DELIVERY_POSSIBLE_AREA_LIST, response.data.list);
    },
    async [actionType.resetStoreDeliveryPossibleAreaList]({ commit }) {
        commit(mutationType.RESET_STORE_DELIVERY_POSSIBLE_AREA_LIST);
    },
    // 등록 기본 메서드
    [actionType._regist]({ state, commit, }, item) {
        if (!item) {
            return;
        }
        // 등록 시 제외 목록에 이미 있다면 제외 목록에서 제거
        const unregisterList = state.unregister
            .filter((unregister) => !isSameDong(unregister, item));
        commit(mutationType.SET_DELIVERY_POSSIBLE_AREA_UNREGISTER, unregisterList);
        // 등록 시 기존 목록에 이미 있다면 아무것도 하지 않음.
        const isOriginHasRegister = state.storeDeliveryPossibleAreaList
            .some((area) => isSameDong(area, item));
        let registerList = state.register;
        if (!isOriginHasRegister) {
            registerList = registerList.concat(item);
        }
        // 등록 목록에 추가
        commit(mutationType.SET_DELIVERY_POSSIBLE_AREA_REGISTER, registerList);
    },
    // 제외 기본 메서드
    [actionType._unregist]({ state, commit, }, item) {
        if (!item) {
            return;
        }
        // 제외 시 등록 목록에 이미 있다면 등록 목록에서 제거
        const registerList = state.register
            .filter((register) => !isSameDong(register, item));
        commit(mutationType.SET_DELIVERY_POSSIBLE_AREA_REGISTER, registerList);
        // 제외 목록에 추가
        const unregisterList = state.unregister
            .concat(item);
        commit(mutationType.SET_DELIVERY_POSSIBLE_AREA_UNREGISTER, unregisterList);
    },
    // 등록
    [actionType.setDeliveryPossibleAreaRegister]({ getters, dispatch, }, item) {
        const isItemRi = isAreaRi(item);
        let eupMyeonDongRiList = [
            item,
        ];
        // 현재 뷰에 나타나는 목록
        const currentViewList = getters.sortedGaiaDongList;
        // 읍면동의 경우 엣지 케이스 (부모 이동 시 자녀 이동 필요)
        if (!isItemRi) {
            // 자녀 리의 목록 확인
            const childRiOfItem = currentViewList.filter((dong) => isChildDong(dong, item));
            eupMyeonDongRiList = eupMyeonDongRiList.concat(childRiOfItem);
        }
        // 리의 경우 엣지 케이스 (마지막 자녀 이동 시 부모 이동 필요)
        if (isItemRi) {
            // 형제 리 목록 확인
            const siblingDongList = currentViewList.filter((dong) => dong.parentId === item.parentId);
            if (siblingDongList.length === 1) {
                const parentOfRiItem = currentViewList.find((dong) => isParentDong(dong, item));
                eupMyeonDongRiList.push(parentOfRiItem);
            }
        }
        eupMyeonDongRiList.forEach((eupMyeonDongRi) => {
            dispatch(actionType._regist, eupMyeonDongRi);
        });
    },
    // 제외
    [actionType.setDeliveryPossibleAreaUnregister]({ getters, dispatch, }, item) {
        const isItemRi = isAreaRi(item);
        let eupMyeonDongRiList = [
            item,
        ];
        // 현재 뷰에 나타나는 목록
        const currentViewList = getters.sortedStoreDongList;
        // 읍면동의 경우 엣지 케이스 (부모 이동 시 자녀 이동 필요)
        if (!isItemRi) {
            // 자녀 리의 목록 확인
            const childRiOfItem = currentViewList.filter((dong) => isChildDong(dong, item));
            eupMyeonDongRiList = eupMyeonDongRiList.concat(childRiOfItem);
        }
        // 리의 경우 엣지 케이스 (자녀 이동 시 부모 이동 필요 / 형제의 이동 불필요)
        if (isItemRi) {
            // 부모 있는지 확인
            const parentOfRiItem = currentViewList.find((dong) => isParentDong(dong, item));
            if (parentOfRiItem) {
                eupMyeonDongRiList.push(parentOfRiItem);
            }
        }
        eupMyeonDongRiList.forEach((eupMyeonDongRi) => {
            dispatch(actionType._unregist, eupMyeonDongRi);
        });
    },
    // 전체 등록
    [actionType.setEveryDeliveryPossibleAreaRegister]({ getters, dispatch, }) {
        const currentViewList = getters.sortedGaiaDongList;
        currentViewList.forEach((dong) => {
            dispatch(actionType._regist, dong);
        });
    },
    // 전체 제외
    [actionType.setEveryDeliveryPossibleAreaUnregister]({ getters, dispatch, }) {
        const currentViewList = getters.sortedStoreDongList;
        currentViewList.forEach((dong) => {
            dispatch(actionType._unregist, dong);
        });
    },
    async [actionType.postDeliveryPossibleArea]({ state, }, storeId = '') {
        if (!storeId) {
            return;
        }
        const registers = state.register.map((dong) => ({
            siDo: dong.siDo,
            siGunGu: dong.siGunGu,
            eupMyeonDong: dong.eupMyeonDong,
        }));
        const unregisters = state.unregister.map((dong) => ({
            siDo: dong.siDo,
            siGunGu: dong.siGunGu,
            eupMyeonDong: dong.eupMyeonDong,
        }));
        await storeService.postStoreDeliveryPossibleAreaList({
            storeId,
            registers,
            unregisters,
        });
    },
    // 일괄 리셋
    [actionType.resetDialog]({ commit }) {
        commit(mutationType.RESET_DIALOG);
    },
};
export default actions;
